import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";

import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";

import bitsOfCode from "../../Assets/Projects/blog.png";
import itask from "../../Assets/Projects/itask.png";
import portfolio from "../../Assets/Projects/portfolio.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="FundCup"
              description="A creator-focused crowdfunding platform built with Next.js and NextAuth (GitHub OAuth). Features a personalized creator dashboard to manage profiles and funding, secure payments via Razorpay, and reliable data storage using MongoDB, all wrapped in a clean, responsive UI."
              ghLink="https://github.com/abhishekc2005/FundCup"
              demoLink="https://fundcup.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bittree"
              description="A full-stack Linktree-style platform built with Next.js to manage and share social links in one place. Features a modern, responsive UI using Tailwind CSS, dynamic routing with unique user handles, and profile customization including image upload and bio management."
              ghLink="https://github.com/abhishekc2005/bittree"
              demoLink="https://bittreeapp.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Bitlinks"
              description="Built a privacy-focused URL shortener enabling instant link generation without user tracking. Developed fast,minimal UI using Next.js and Tailwind CSS with MongoDb Atlas for persistence."
              ghLink="https://github.com/abhishekc2005/bitlinks"
              demoLink="https://bitlinks-ivory-pi.vercel.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="PassOp"
              description="Developed a full-stack MERN password manager enabling users to securely store,edit,delete and copy credentials. Built responsive frontend using React(Vite) and Tailwind CSS with real-time feedback via React Toastify. Designed RESTful APIs using Express.js and integrated MongoDb Atlas for persistent data storage."
              ghLink="https://github.com/abhishekc2005/PassOp-Client"
              demoLink="https://pass-op-client.vercel.app/"
            />
          </Col>

           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={itask}
              isBlog={false}
              title="iTask"
              description="iTask is a responsive and intuitive To-Do List web application built with React, Vite, and Tailwind CSS. It allows users to add, edit, delete, and manage tasks efficiently, with the ability to mark tasks as completed. The project focuses on clean UI, smooth user experience, and modern frontend best practices, helping reinforce core React concepts and component-based design."
              ghLink="https://github.com/abhishekc2005/iTask"
              demoLink="https://i-task-coral.vercel.app/"
            />
          </Col>

            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="Personal Portfolio Website"
              description="A React + Bootstrap powered personal portfolio showcasing my work, resume, projects, certifications, GitHub activity, and contact links in a clean, responsive layout."
              ghLink="https://github.com/abhishekc2005/acdevportfolio"
              demoLink="https://acdevportfolio.vercel.app/"
            />
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;